import axios from 'axios';

const url = 'https://covid-insights-app.herokuapp.com/global/';
const url1 = 'https://covid-insights-app.herokuapp.com/countries';

export const fetchData = async (country) => {
  let changeableUrl = url;

  if (country) {
    changeableUrl = `${url1}/${country}`;
  }

  try {
    const { data } = await axios.get(changeableUrl);

    if(country) {

      var arr1 = data;
      console.log("arr1 ");
      console.log(arr1);

      return arr1; 
    } else {

      var arr2 = data["Global"];
      arr2["date"] = data["Date"];
      arr2["td"] = data["topDeath"];
      arr2["tc"] = data["topConfirmed"];
      arr2["tr"] = data["topRecovered"];
      arr2["tnd"] = data["topNewDeath"];
      arr2["tnc"] = data["topNewConfirmed"];
      arr2["tnr"] = data["topNewRecovered"];
      
      console.log(arr2);

      return arr2;
    }
  } catch (error) {
    return error;
  }
};

export const fetchDailyData = async (country) => {
  try {
    const { data } = await axios.get(`${url1}/${country}`);

    let arr = data["countryAllData"];
    console.log("countryAllData")
    console.log(arr);

    return arr;
  } catch (error) {
    return error;
  }
};

export const fetchCountries = async () => {
  try {

    const { data } = await axios.get(url);
    var arr = data["Countries"];
    
    console.log(arr);
    return arr;

  } catch (error) {
    return error;
  }
};
